import {
  EXIBIR_CARREGANDO,
  LIST_CATEGORY_OPERATIONS,
  LIST_FARM_CONCILIATIONS,
} from "../../../redux/actions/actionsConstants";

export const listarConciliacoesFazenda = (conciliacoes) => {
  return {
    type: LIST_FARM_CONCILIATIONS,
    payload: { ConciliacoesFazenda: conciliacoes },
  };
};

export const listarDetalhesCategoria = (operacoes) => {
  return {
    type: LIST_CATEGORY_OPERATIONS,
    payload: { OperacoesCategoria: operacoes },
  };
};

export const exibirCarregando = (exibir) => {
  return {
    type: EXIBIR_CARREGANDO,
    payload: exibir,
  };
};
